class Version {
    static get FullVersion(): string {
        var DO_NOT_CHANGE_ABCDEF = "1.0.3.205";
        return DO_NOT_CHANGE_ABCDEF;
    }
};

export default Version;
